/* eslint-disable */

/** unique or primary key constraints on table "argo.material_model_process" */
export enum ArgoMaterialModelProcessConstraint {
  /** unique or primary key constraint on columns "material_model_process_id" */
  MaterialModelProcessPkey = 'material_model_process_pkey',
  /** unique or primary key constraint on columns "process_id", "material_model_id" */
  MaterialModelProcessUnique = 'material_model_process_unique'
}

/** select columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_process_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "argo_material_model_process_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** update columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

